import { OpenFacetsButton } from "./components/openFacetsButton/openFacetsButton.component";
import { Base } from "./facets.base";
import { BaseProductFacets } from "./variants/base";
import { MobileFacets } from "./variants/mobileFacets";
import { NonMobileFacets } from "./variants/nonMobileFacets";

export const Facets = Object.assign(Base, {
    Variants: { Mobile: MobileFacets, NonMobile: NonMobileFacets },
    Product: BaseProductFacets,
    OpenFacetsButton: OpenFacetsButton
});
